import React from 'react';
import './PaymentMethod.css';

const PaymentMethod = ({ icon, title, originalPrice, finalPrice, selected, onChange }) => {
  return (
    <div 
      className={`payment-method ${selected ? 'selected' : ''}`}
      onClick={onChange}
    >
      <div className="payment-icon">{icon}</div>
      <div className="payment-info">
        <h4>{title}</h4>
        {originalPrice && (
          <span className="original-price">$ {originalPrice.toLocaleString('es-AR')}</span>
        )}
        <span className="final-price">$ {finalPrice.toLocaleString('es-AR')}</span>
      </div>
      <input 
        type="radio" 
        checked={selected}
        onChange={onChange}
        className="payment-radio"
      />
    </div>
  );
};

export default PaymentMethod;
